import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { UiModalRef } from "@webapp/ui/modal/abstracts/modal-ref";
import { UI_MODAL_DATA } from "@webapp/ui/modal/modal.models";

export type FeedbackType = "positive" | "negative";

@Component({
  selector: "pi-feedback",
  templateUrl: "./pi-feedback.component.html",
  styleUrls: ["./pi-feedback.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PiFeedbackComponent {
  public userFeedback: string;
  public feedbackType: FeedbackType;

  constructor(private modalRef: UiModalRef, @Inject(UI_MODAL_DATA) modalData: FeedbackType) {
    this.feedbackType = modalData;
  }

  public handleSubmitFeedback = (): void => {
    this.modalRef.close(this.userFeedback);
  };

  public handleClose = (): void => {
    this.modalRef.close();
  };
}
